import React, { useState } from 'react';

const Star = ({ filled, half, onClick }) => (
  <span 
    className="cursor-pointer text-2xl" 
    onClick={onClick}
  >
    {filled ? ' \u2B50 ' : half ? '½' : '☆'}

  </span>
);

 const StarRating = ({ rating, onRatingChange }) => {
  const [hoverRating, setHoverRating] = useState(0);

  const handleClick = (index) => {
    if (index === rating && index > 0.5) {
      onRatingChange(index - 0.5);
    } else {
      onRatingChange(index);
    }
  };

  return (
    <>
    <div className="flex ">
      {[1, 2, 3, 4, 5, 6, 7].map((index) => (
        <Star
          className="text-yellow-500"
        key={index}
          filled={index <= (hoverRating || rating)}
          half={index - 0.5 === (hoverRating || rating)}
          onClick={() => handleClick(index)}
          onMouseEnter={() => setHoverRating(index)}
          onMouseLeave={() => setHoverRating(0)}
        />
      ))}
    </div>
    <p className="flex text-gray-100 font-bold font-sans text-sm">{rating} / 7</p>
    </>
  );
};
export default StarRating;
